import { createApi } from '@reduxjs/toolkit/query/react'

import { ApiResponse } from '@api/types/api-response.type'

import baseQueryInterceptor from './base-query-interceptor'

export const healthCheckApi = createApi({
  reducerPath: 'healthCheckApi',
  baseQuery: baseQueryInterceptor,
  endpoints: (builder) => ({
    healthCheck: builder.query<ApiResponse<any>, void>({
      query: () => ({
        url: `/health-check`,
        method: 'get',
      }),
    }),
  }),
})

export const { useLazyHealthCheckQuery } = healthCheckApi
